import { BaseGraph } from './BaseGraph';

export class EmptyGraph implements BaseGraph {
  public graph;
  getText(): string {
    return 'EmptyGraph-getText()';
  }
}
